module.exports = {
  FEEDBACK_TIME: 10000,
  MAX_TIME: 25000,
  MAX_REMOTE_CALL_TIME: 60000,
  OPERATOR_TOOLS_FEEDBACK_TIME: 30000,
  OPERATOR_TOOLS_MAX_TIME: 90000,
};
